<template>
    <div>
        <!-- Modal Obter Credenciais do Reembolso -->
        <div class="modal fade" id="obterCredReembolsoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Obter Credenciais
                            <span class="badge badge-secondary ml-3" v-if="numero_atend">{{ numero_atend }}</span>
                        </h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="retorno">
                            <div class="card az-anime-surgir">
                                <div class="card-body text-center">
                                    <i class="fa fa-check-circle-o text-success fa-7x mb-3" aria-hidden="true"></i>
                                    <h2>Credenciais atualizadas com sucesso!</h2>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="qrCode">
                            <div class="alert alert-info mb-0 d-flex justify-content-between" v-if="carregado">
                                <div>
                                    O paciente deve fazer a leitura do QRCode para envio das credenciais:
                                </div>
                                <div>
                                    <a :href="qrCode" class="card-link" target="_blank">
                                        <i class="fas fa-link"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="text-center">

                            <qr-code :text="qrCode" :size="200" class="d-flex justify-content-center my-3"></qr-code>

                            
                            <img @load="onImgLoad"
                                v-if="false"
                                :src="
                                    'https://chart.googleapis.com/chart?cht=qr&chl=' +
                                    encodeURIComponent(qrCode) +
                                    '&choe=UTF-8&chs=250x250'
                                "
                                class="img-fluid"
                                />

                            </div>

                            <div v-if="contatos">
                                <az-input
                                    icon="far fa-envelope fa-fw"
                                    type="email"
                                    v-model="contatos.email">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-success" :disabled="$store.state.loading" @click="enviar_para_paciente()">
                                                <i class="fas fa-share"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input
                                    icon="fa fa-mobile fa-fw"
                                    type="fone"
                                    v-model="contatos.celular">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <a class="btn btn-success" :href="enviar_para_whatsapp()" target="_blank" v-if="contatos.celular">
                                                <i class="fas fa-share"></i>
                                            </a>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div v-if="retorno || qrCode">  

                            <div v-if="marcacao.credenciais" class="mt-3">

                                <div class="d-flex justify-content-between">

                                    <div>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" 
                                                id="invalido" 
                                                v-model="marcacao.credenciais.fl_invalido" 
                                                @change="toggle_invalido(marcacao.credenciais)">
                                            <label class="custom-control-label" for="invalido">
                                                Inválido
                                            </label>
                                        </div>
                                    </div>

                                    <a href="#" @click.prevent="exibicao = !exibicao" class="card-link">
                                        <i class="fa fa-eye fa-fw" aria-hidden="true" v-if="exibicao"></i>
                                        <i class="fa fa-eye-slash fa-fw" aria-hidden="true" v-else></i>
                                    </a>
                                    
                                </div>

                                <div class="alert d-flex justify-content-between mt-3 mb-2" :class="marcacao.credenciais.fl_invalido ? 'alert-danger' : 'alert-secondary'">
                                    <div>
                                        {{ exibicao ? marcacao.credenciais.st_login : '---' }}</div>
                                    <div>
                                        <a href="#" @click.prevent="copiar_clipboard(marcacao.credenciais.st_login)">
                                            <i class="fas fa-copy"></i>
                                        </a>
                                    </div>
                                </div>

                                <div class="alert d-flex justify-content-between mb-0" :class="marcacao.credenciais.fl_invalido ? 'alert-danger' : 'alert-secondary'">
                                    <div>{{ exibicao ? marcacao.credenciais.st_senha : '---' }}</div>
                                    <div>
                                        <a href="#" @click.prevent="copiar_clipboard(marcacao.credenciais.st_senha)">
                                            <i class="fas fa-copy"></i>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="!carregado">
                            <az-loading />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" title="Reintegrar Credencial" v-if="esta_integrado" @click="reintregar_credencial(marcacao)">
                            <i class="fa-solid fa-tower-cell"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash';
import $ from 'jquery';
import AzLoading from '../../util/AzLoading.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
    data() { 
        return { 
            marcacao: null, 
            qrCode: "abcde",
            carregado: false, 
            contatos: null, 
            exibicao: false, 
            retorno: null, 
        }
    },

    components: { 
        AzLoading,
        AzInput, 
    },

    computed: { 
        esta_integrado: function () { 
            if ( this.marcacao && this.marcacao.st_id_externo && this.marcacao.st_id_externo.indexOf(':') > 0 ) { 
                return true;
            }

            if ( this.marcacao && this.marcacao.marcacao && this.marcacao.marcacao.st_id_externo && this.marcacao.marcacao.st_id_externo.indexOf(':') > 0 ) { 
                return true;
            }

            return false;
        },

        numero_atend: function () { 
            let numero;

            if ( this.marcacao && this.marcacao.id_atendimento ) { 

                numero = '#' + this.marcacao.id_atendimento;

                if ( this.marcacao.st_id_externo ) { 
                    numero = numero + ' / ' + this.marcacao.st_id_externo;
                }

                return numero;
            } else if ( this.marcacao && this.marcacao.marcacao && this.marcacao.marcacao.id_atendimento ) { 
                
                numero = '#' + this.marcacao.marcacao.id_atendimento;

                if ( this.marcacao.marcacao.st_id_externo ) { 
                    numero = numero + ' / ' + this.marcacao.marcacao.st_id_externo;
                }

                return numero;
            }

            return "";
        }
    },

    methods: { 
        reintregar_credencial (marcacao) { 
            let id_marcacao; 

            if ( marcacao && marcacao.id_marcacao ) { 
                id_marcacao = marcacao.id_marcacao;
            } else if ( marcacao && marcacao.marcacao && marcacao.marcacao.id_marcacao ) { 
                id_marcacao = marcacao.marcacao.id_marcacao;
            } else { 
                this.$toast.add({ 
                    severity: "error",
                    summary: "Integrar Credenciais",
                    detail: "Marcação não identificada.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: 'reembolsos',
                func: 'reintegrar_credencial',
                dados: { 
                    id_marcacao: id_marcacao
                }, 
            });
        },

        toggle_invalido (cred) { 
            this.$util.atualizar(this, { 
                service: 'reembolsos',
                func: 'login_invalido',
                dados: cred, 
                callback: () => { 
                    this.$emit("refresh");
                }
            });
        },

        fechar() { 
            $('#obterCredReembolsoModal').modal('hide');
        },

        onImgLoad() { 
            this.carregado = true;
        },

        enviar_para_whatsapp() { 

            let nl = "%0D%0A";
            let msg = "Prezado(a) ";
            let celular = "";

            msg = msg + this.contatos.nome;
            celular = this.contatos.celular;
            
            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = "55" + celular;

            msg = msg + nl;
            msg = msg + "Link para envio das credenciais de acesso:" + nl;
            msg = msg + encodeURIComponent(this.qrCode);

            return "https://wa.me/" + celular + "?text=" + msg;

        },

        abrir(marcacao) { 
            if ( this.canal ) { 
                unSubscribe(this.canal, "reemb-cred");
            }

            this.carregado = false;
            this.marcacao = null;
            this.contatos = null;
            this.retorno = null;

            this.$nextTick(() => { 
                this.marcacao = marcacao;
                this.qrCode = null;

                this.$store.commit("loading", true);

                this.axios
                    .post(
                        "/reembolso/link", 
                        { 
                            id_marcacao: marcacao.id_marcacao,
                            id_solicitacao_autorizacao: marcacao.id_solicitacao_autorizacao  
                        })
                    .then(res => {
                        if (res.response && res.response.status > 400) {
                            this.status = res.response.data;
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.response.data,
                                life: 3000
                            });
                        } else {
                            this.qrCode = res.data.link;
                            this.contatos = res.data;

                            this.canal = '';

                            if ( marcacao.id_paciente > 0 ) { 
                                this.canal = '.reemb-cred.' + marcacao.id_paciente;
                            } else if ( marcacao.id_solicitacao_autorizacao > 0 ) { 
                                this.canal = '.reemb-cred-sol.' + marcacao.id_solicitacao_autorizacao;
                            }

                            if ( this.canal ) { 
                                this.canal = this.$store.state.dominio + this.canal;

                                subscribe(this.canal, "reemb-cred", res => { 
                                    this.retorno = res;

                                    this.marcacao.credenciais = this.retorno.data;

                                    this.$emit("refresh");
                                });
                            }
                        }
                    })
                    .catch(err => {
                        alert(err);
                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                        this.carregado = true;
                    });

                $('#obterCredReembolsoModal').modal('show');
            });
        },

        enviar_para_paciente() {

            let texto = "Prezado(a) " + this.contatos.nome;
            texto += "\n \n";
            texto += "Segue link para envio das credenciais de acesso.";
    
            this.$util.atualizar(this, { 
                service: 'mensagens',
                func: 'enviar',
                dados: { 
                    texto: texto,
                    assunto: 'Credenciais de Acesso para Reembolso',
                    por: 'M', 
                    destino: this.contatos.email,
                    link: this.qrCode, 
                },
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atualizar",
                        detail: "Mensagem enviada para o paciente.",
                        life: 3000
                    });
                }
            });

        },

        copiar_clipboard (text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "'" + text + "' copiado para a área de transferência.",
                life: 3000
            });
        },
    },

    beforeDestroy() { 
        if ( this.canal ) { 
            unSubscribe(this.canal, "reemb-cred");
        }
    }

}
</script>